import { Building2 } from "lucide-react";

const BusinessPortal = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="text-center space-y-8 max-w-2xl animate-fade-in">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-primary opacity-20 blur-3xl rounded-full"></div>
            <Building2 className="w-24 h-24 mx-auto text-turquoise relative z-10" />
          </div>
          <div className="space-y-4">
            <h1 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-turquoise to-turquoise-light bg-clip-text text-transparent">
              Coming Soon
            </h1>
            <p className="text-xl text-muted-foreground">
              Unser Business Portal befindet sich derzeit in der Entwicklung.
            </p>
            <p className="text-muted-foreground">
              Bald können Sie hier Ihre Sporteinrichtungen verwalten und mit der
              OffTogether Community verbinden.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default BusinessPortal;
